export const XOA_HOP_DONG = "XOA_HOP_DONG";
export const XOA_HOP_DONG_SUCCESS = "XOA_HOP_DONG_SUCCESS";
export const XOA_HOP_DONG_FAILURE = "XOA_HOP_DONG_FAILURE";

export const SHOW_XOA_HOP_DONG = "SHOW_XOA_HOP_DONG";

export const CHECK_XOA_HOP_DONG = "CHECK_XOA_HOP_DONG";
export const CHECK_XOA_HOP_DONG_SUCCESS = "CHECK_XOA_HOP_DONG_SUCCESS";
export const CHECK_XOA_HOP_DONG_FAILURE = "CHECK_XOA_HOP_DONG_FAILURE";
